import { emitDataRow1Port, emitDataRow2Port } from './data-row.js';
import { toMA } from './format-convert.js';
import { emitOptionLine } from './option-line.js';
function sanitizeHeaderField(s) {
    return s.replace(/[\r\n]+/g, ' ');
}
function formatTimestamp(ms) {
    return new Date(ms).toISOString();
}
const ZERO_COMPLEX = { re: 0, im: 0 };
export function writeTouchstoneString(trace) {
    const lines = [];
    const source = trace.driverKind === 'v1'
        ? 'NanoVNA V1'
        : trace.driverKind === 'v2'
            ? 'NanoVNA V2'
            : 'Imported';
    const isTwoPort = trace.frame.s21 !== undefined;
    lines.push('! Generated by NanoVNAWeb');
    lines.push(`! Source: ${source}`);
    lines.push(`! Trace: ${sanitizeHeaderField(trace.name)}`);
    lines.push(`! Recorded: ${formatTimestamp(trace.createdAt)}`);
    if (isTwoPort) {
        lines.push('! S12 and S22 are zero — NanoVNA hardware measures S11 and S21 only');
    }
    lines.push(emitOptionLine());
    const freqs = trace.frame.frequencies;
    const s11 = trace.frame.s11;
    const s21 = trace.frame.s21 ?? [];
    for (let i = 0; i < freqs.length; i++) {
        const freq = freqs[i] ?? 0;
        const s11v = s11[i] ?? ZERO_COMPLEX;
        if (isTwoPort) {
            const s21v = s21[i] ?? ZERO_COMPLEX;
            lines.push(emitDataRow2Port(freq, toMA(s11v), toMA(s21v)));
        }
        else {
            lines.push(emitDataRow1Port(freq, toMA(s11v)));
        }
    }
    return `${lines.join('\n')}\n`;
}
//# sourceMappingURL=writer.js.map